import React, { useEffect, useRef } from 'react'
import './customCheckBox.css'

export const CustomCheckBox = ({
  checked,
  onChange,
  disabled = false,
  id,
  indeterminate = false,
  'aria-label': ariaLabel,
  wrapperTestId,
  'data-testid': dataTestId,
}) => {
  const checkboxRef = useRef(null)
  const inputId = id || dataTestId

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate
    }
  }, [indeterminate])

  return (
    <div className="checkbox-wrapper-65" data-testid={wrapperTestId}>
      <label htmlFor={inputId}>
        <input
          ref={checkboxRef}
          type="checkbox"
          id={inputId}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          aria-label={ariaLabel}
          data-testid={dataTestId}
        />
        <span className={indeterminate ? 'cbx indeterminate' : 'cbx'}>
          <svg width="12px" height="11px" viewBox="0 0 12 11">
            <polyline points="1 6.29411765 4.5 10 11 1"></polyline>
          </svg>
        </span>
      </label>
    </div>
  )
}
